/**
 * A stat chip (.reel-chip — the novel detail's meta bar, the author's ribbon)
 * while its figure loads: the chip's own box with a bar for the number and one
 * for the label, at their loaded line heights. The caller hides the row from
 * assistive tech.
 */
export function ReelChipSkeleton() {
  return (
    <div className="reel-chip reel-chip--skeleton">
      <span className="skeleton reel-chip-figure-skeleton" />
      <span className="skeleton reel-chip-label-skeleton" />
    </div>
  );
}
